// extracted by mini-css-extract-plugin
module.exports = {"row":"CouponsList_row__4ARGy","col":"CouponsList_col__3Ib9k","card":"CouponsList_card__2CYPh"};